import { levelTwoNavigationSelectors as selector } from "../Selectors/index";

export const levelTwoNavigationReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET_LEVEL_TWO_ROLE_SUCCESS:
      return payload;

    default:
      return state;
  }
};